<ng-container *ngIf="form != undefined">
    <div class="general">
        <div class="define-size">
            <div [formGroup]="form" class="button-area">
                <button *ngFor="let number of numbers;" class="number" [ngStyle]="objColor" (click)="setFormValue(number)">{{number}}</button>
            </div>
            <div class="score-area">
                <p class="low-score">{{low_score_label}}</p>
                <p class="high-socre">{{high_score_label}}</p>
            </div>
        </div>
    </div>
</ng-container>